import { render, staticRenderFns } from "./setContents.vue?vue&type=template&id=24ecc85e&"
import script from "./setContents.vue?vue&type=script&lang=js&"
export * from "./setContents.vue?vue&type=script&lang=js&"
import style0 from "./setContents.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports